import axios from "../utils/axios";

export const home = (data) => { 
    return axios({
        method:'post',
        url:"/api/yibaoyi/home",
        data:data,
    });
}
export const rotationmap = (data) => { 
    return axios({
        method:'post',
        url:"/api/yibaoyi/banner",
        data:data,
    });
}
export const course = (data) => { 
    return axios({
        method:'get',
        url:"/api/yibaoyi/course",
        data:data,
    });
}
export const price = (data) => { 
    return axios({
        method:'get',
        url:"/api/yibaoyi/price",
        data:data,
    });
}
export const ecology = (data) => { 
    return axios({
        method:'get',
        url:"/api/yibaoyi/ecology",
        data:data,
    });
}
export const about = (data) => { 
    return axios({
        method:'get',
        url:"/api/yibaoyi/about",
        data:data,
    });
}
export const service = (data) => { 
    return axios({
        method:'get',
        url:"/api/yibaoyi/service",
        data:data,
    });
}
export const hot = (data) => { 
    return axios({
        method:'get',
        url:"/api/yibaoyi/hot",
        data:data,
    });
}
export const tip = (data) => { 
    return axios({
        method:'get',
        url:"/api/yibaoyi/tip",
        data:data,
    });
}
export const article = (data) => { 
    return axios({
        method:'post',
        url:"/api/yibaoyi/article",
        data:data,
    });
}
export const articlede = (data) => { 
    return axios({
        method:'post',
        url:"/api/yibaoyi/articlede",
        data:data,
    });
}
export const bottom = (data) => { 
    return axios({
        method:'post',
        url:"/api/yibaoyi/bottom",
        data:data,
    });
}
export const seo = (data) => { 
    return axios({
        method:'post',
        url:"/api/yibaoyi/seo",
        data:data,
    });
}
export const casedata = (data) => { 
    return axios({
        method:'post',
        url:"/api/yibaoyi/casedata",
        data:data,
    });
}
export const casedatade = (data) => { 
    return axios({
        method:'post',
        url:"/api/yibaoyi/casedatade",
        data:data,
    });
}
export const fromMsg = (data) => { 
    return axios({
        method:'post',
        url:"/api/yibaoyi/fromMsg",
        data:data,
    });
}
export const product = (data) => { 
    return axios({
        method:'post',
        url:"/api/yibaoyi/product",
        data:data,
    });
}
export const productleft = (data) => { 
    return axios({
        method:'post',
        url:"/api/yibaoyi/productleft",
        data:data,
    });
}
